import React, { useEffect } from 'react';

import { saveServiceGeoLocationData } from './../../../../../../utils/common';
import { GetGeoLocationFormFragmentProps } from './GetGeoLocationFormFragment.props';
import { toast } from '../../../../../../utils/toast';

/**
 * Captures the technician's position against the service. It renders nothing —
 * the only thing it ever showed was a failure message, and that now goes to the
 * shared toast.
 */
export const GetGeoLocationFormFragment: React.FC<GetGeoLocationFormFragmentProps> = ({
  service,
}) => {
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const serviceBasedPositionData = {
            serviceId: service.id,
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            accuracy: position.coords.accuracy || 0,
            altitude: position.coords.altitude || 0,
            altitudeAccuracy: position.coords.altitudeAccuracy || 0,
            heading: position.coords.heading || 0,
            speed: position.coords.speed || 0,
          };
          return saveServiceGeoLocationData(serviceBasedPositionData);
        },
        (error) => {
          toast.error(error.message);
        }
      );
    } else {
      toast.error('Geo-Location data not retrieved');
    }
  }, [navigator.geolocation]);

  return null;
};
